import { useIntl } from "react-intl"
import useFormaters from "components/Shared/Hooks/useFormatters"
import { INDEX_RATE } from "components/Transactional/Benchmark/Benchmark.constant"
import { CommercialBenchmarkVsmNode } from "components/Transactional/Performance/components/SummaryTable/SummaryTable.domain"
import {
	useGetLevelTranslate,
	columnTranslate,
} from "components/Shared/Hooks/useGetLevelTranslate/useGetLevelTranslate"

const BASE =
	"phronesis.transactional.application.commercial.benchmark.vsm.summary"
const PERCENTAGE_CONFIG = { decimals: 2, withPercentageChar: true }

const createIntlField = (id: string) => ({ intl: { id } })
const useVsmConfig = () => {
	const { formatMessage } = useIntl()
	const { formatNumber: number, formatPercentage: percentage } = useFormaters()

	const nodeToTableFormat = (node: CommercialBenchmarkVsmNode) => {
		const { commercialBenchmarkVsmDetails, identifierName } = node
		const {
			currentClientsVendor,
			previousClientsVendor,
			currentClientsWalmart,
			previousClientsWalmart,
			currentVariation,
			previousVariation,
		} = commercialBenchmarkVsmDetails

		const getVariations = (variation: number, identifierName: string) => {
			return identifierName == INDEX_RATE
				? number(variation)
				: percentage(variation, PERCENTAGE_CONFIG)
		}

		const currentVariationFormatted = getVariations(
			currentVariation,
			identifierName
		)
		const previousVariationFormatted = getVariations(
			previousVariation,
			identifierName
		)

		return {
			title: formatMessage({ id: `${BASE}.title.${identifierName}` }),
			content: formatMessage({ id: `${BASE}.tooltip.${identifierName}` }),
			headers: [
				{
					id: "totalClients",
					...createIntlField(`${BASE}.header.${node.identifierName}`),
				},
				{
					id: "currentClients",
					...createIntlField(`${BASE}.header.current_period`),
				},
				{
					id: "previousClients",
					...createIntlField(`${BASE}.header.previous_period`),
				},
			],
			data: [
				{
					totalClients: columnTranslate(identifierName),
					currentClients: number(currentClientsVendor),
					previousClients: number(previousClientsVendor),
				},
				{
					totalClients: useGetLevelTranslate(
						`${BASE}.side_header.row_2`,
						identifierName
					),
					currentClients: number(currentClientsWalmart),
					previousClients: number(previousClientsWalmart),
				},
				{
					totalClients: createIntlField(
						`${BASE}.side_header.row_3.${identifierName}`
					),
					currentClients: currentVariationFormatted,
					previousClients: previousVariationFormatted,
				},
			],
			principalMetric: currentVariationFormatted,
			legend: formatMessage({
				id: `${BASE}.legend`,
			}),
		}
	}

	return { nodeToTableFormat }
}

export default useVsmConfig
